import React from 'react';

const Logo = ({ width = "208", height = "32", textFill = "white" }) => {
    return (
        <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-gradient-to-br from-blue-400 to-purple-600 rounded-lg flex items-center justify-center">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
            <span 
                className="font-bold text-xl font-['Oswald']"
                style={{ color: textFill, fontSize: `${parseInt(height) * 0.6}px` }}
            >
                Rocket Lab Ventures
            </span>
        </div>
    );
};

export default Logo;